import { HelpHomeTemplateType } from './HelpHomeTemplate';
import React from 'react';
import { PageHead } from '../../Layout';
import { ThemeProvider } from 'styled-components';
import { lightTheme } from '../../Theme';
import { getTemplateSocialCardUrl } from '../socialCard';
import { HelpList } from '../../Help/HelpList';
import { articleUrl, FaqArticle, FaqCategory } from '../../Help/util';
import { Box } from '../../ui';
import { useT } from '@spotify-internal/i18n-core';

interface HelpArticleTemplateType {
  template: HelpHomeTemplateType;
  category?: FaqCategory;
  article: FaqArticle;
  preview?: boolean;
}

export const HelpArticleTemplate: React.FC<HelpArticleTemplateType> = ({
  template,
  category,
  article,
}) => {
  const t = useT();
  return (
    <ThemeProvider theme={lightTheme}>
      <PageHead
        title={`${t('FRODOR_1d93a2', 'Help', '')} - ${article.question}`}
        description={article.question}
        image={getTemplateSocialCardUrl(template)}
        canonicalUrl={articleUrl(article)}
      />
      <Box noPadding>
        <HelpList
          faqCategories={template.faqCategories || []}
          currentCategory={category}
          currentArticle={article}
        />
      </Box>
    </ThemeProvider>
  );
};
